import { inject, provide } from "vue";

import { useRoute, useRouter, type RouteLocationNormalizedLoaded, type Router } from "vue-router";

const RouteContextKey = Symbol("RouteContext");
const RouterContextKey = Symbol("RouterContext");

export const provideRouteContext = () => {
  const route = useRoute();
  provide(RouteContextKey, route);
  return route;
};

export const provideRouterContext = () => {
  const router = useRouter();
  provide(RouterContextKey, router);
  return router;
};

export const useRouteContext = () => inject<RouteLocationNormalizedLoaded>(RouteContextKey, useRoute());

export const useRouterContext = () => inject<Router>(RouterContextKey, useRouter());
